import React, { useState } from 'react';
import { BrowserRouter, Routes, Route, Link, useParams, Navigate } from 'react-router-dom';
import Blog from './Blog.js';
import Whitepaper from './Whitepaper.js';
import Article from './Article.js';

function isValidEmail(email) {
  const emailRegex = /^[^\s@]+@[^\s@]+$/;
  return emailRegex.test(email);
}

function isValidComment(comment) {
  return comment.trim() !== '';
}

function App() {
  const [isNavOpen, setIsNavOpen] = React.useState(false);
  const [email, setEmail] = React.useState('');
  const [comment, setComment] = React.useState('');
  const [status, setStatus] = React.useState('idle');
  const [response, setResponse] = React.useState('');
  const [showCommentInput, setShowCommentInput] = React.useState(false);
  const [name, setName] = useState('');
  const [isNameInvalid, setIsNameInvalid] = useState(false);
  const [isEmailInvalid, setIsEmailInvalid] = useState(false);
  const [organization, setOrganization] = React.useState('');

  const commentRef = React.useRef(null);

  React.useEffect(() => {
    if (status === 'comment' && commentRef.current) {
      commentRef.current.focus();
    }
  }, [status]);

  const handleEmailSubmit = async () => {
    if (!name) {
      setIsNameInvalid(true);
      return;
    }
    if (!email) {
      setIsEmailInvalid(true);
      return;
    }
    try {
      const res = await fetch(
        'https://us-central1-console1-912e9.cloudfunctions.net/api/addEmail',
        {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ 
            value: { 
              name,          // ✅ FIXED: Now sending name
              email,         // ✅ Already being sent
              organization   // ✅ FIXED: Now sending organization
            } 
          }),
        }
      );
      if (!res.ok) {
        throw new Error('Network response was not ok');
      }
      setStatus('comment');
      setShowCommentInput(true);
    } catch (error) {
      console.error('Failed to submit email:', error);
      setStatus('error');
      setResponse('Oops! Something went wrong. Please try again.');
    }
  };

  const register = async () => {
    setStatus('uploading');
    setResponse('Registering');
    try {
      const res = await fetch(
        'https://us-central1-console1-912e9.cloudfunctions.net/api/setEmail',
        {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            key: 'landing-page-emails',  // REQUIRED because your backend expects it!
            value: {
              name,
              email,
              organization,
              comment
            }
          }),
        }
      );
  
      if (res.ok) {
        setEmail('');
        setComment('');
        setName('');
        setOrganization('');
        setStatus('success');
        setResponse('Success! You will be notified at: ' + email);
      } else {
        throw new Error('Internal server error!');
      }
    } catch (error) {
      console.error(error);
      setStatus('error');
      setResponse('Oops! Something went wrong. Please try again.');
    }
  };

  const blogPosts = [
    {
      id: 1,
      title: 'Introducing Console One',
      date: '2024-03-20',
      content: (
        <>
          <p>
            Today we're excited to announce Console One, a revolutionary
            platform that's changing how developers build software. Console One
            integrates seamlessly into your existing workflows, providing a
            unified solution for all your development needs.
          </p>
          <p>With Console One, you can expect:</p>
          <ul>
            <li>Enhanced collaboration among team members.</li>
            <li>Streamlined processes that reduce development time.</li>
            <li>Powerful AI-driven tools that assist in coding, testing, and deployment.</li>
          </ul>
          <p>
            Join us as we embark on this journey to redefine software
            development!
          </p>
        </>
      ),
    },
    {
      id: 2,
      title: 'The Future of AI-Driven Development',
      date: '2024-03-18',
      content: null,
    },
    {
      id: 3,
      title: 'Streamlining Your Development Workflow',
      date: '2024-03-15',
      content: null,
    },
  ];

  const ArticleWrapper = () => {
    const { id } = useParams();
    const articleId = parseInt(id, 10);
    const article = blogPosts.find((post) => post.id === articleId);
    return (
      <Article
        title={article ? article.title : null}
        date={article ? article.date : null}
        content={article ? article.content : null}
      />
    );
  };

  return (
    <BrowserRouter>
      <div className="App">
        <nav className="navbar">
          <div className="nav-logo">
         <img
                  src="/logo.png"
                  alt="Console One Logo"
                  className="logo"
              />
          </div>
          <div className="hamburger" onClick={() => setIsNavOpen(!isNavOpen)}>
            <span></span>
            <span></span>
            <span></span>
          </div>
          <ul className={`nav-links ${isNavOpen ? 'active' : ''}`}>
            <li>
              {/* <Link to="/blog" onClick={() => setIsNavOpen(false)}>
                Blog
              </Link> */}
            </li>
            <li>
              {/* <Link to="/whitepaper" onClick={() => setIsNavOpen(false)}>
                Whitepaper
              </Link> */}
            </li>
            <li>
              <a
                href="mailto:brett@netos.one"
                className="contact-button"
                onClick={() => setIsNavOpen(false)}
              >
                Contact
              </a>
            </li>
          </ul>
        </nav>

        <div className="main-content">
          <Routes>
            <Route path="/blog" element={<Blog />} />
            <Route path="/whitepaper" element={<Whitepaper />} />
            <Route path="/article/:id" element={<ArticleWrapper />} />
            <Route
              path="/"
              element={
                <>
                  <div className="landing-page">
                    <div className="hero-section">
                      <div className="story-lens-header">
                        <span className="story-lens-bold">StoryLens</span>
                        <span className="story-lens-grey"> by Console One</span>
                      </div>
                      <h1>The Story Engine for Your Business</h1>
                      <p className="hero-description">
                      The first AI-driven tool that helps you understand the 'story' of what's actually happening across your business.
                      </p>
                      <p className="hero-description">
                      Built for Directors, Eng Managers, PMs, HR - anyone working to align teams before drift, delays, or debt take hold.
                      </p>
                      <p className="hero-description">
                      Led by the engineers behind Amazon's global workforce systems.                      
                      </p>
                    </div>
                    <div className="email-signup" >
                      <form
                        className="input-button-container"
                        style={{
                          display: 'flex',
                          flexDirection: 'column',
                          gap: '16px',
                          marginBottom: '1rem',
                          alignItems: 'flex-start',
                        }}
                        onSubmit={(e) => {
                          e.preventDefault();
                          handleEmailSubmit();
                        }}
                      >
                        <div style={{ width: '100%' }}>
                          <input
                            type="text"
                            spellCheck="false"
                            placeholder="Your name"
                            value={name}
                            disabled={showCommentInput}
                            onChange={(e) => setName(e.target.value)}
                            required
                          />
                          <span
                            style={{
                              color: isNameInvalid ? 'black' : 'black',
                              fontSize: '0.75rem',
                              display: 'block',
                              marginTop: '4px',
                              animation: isNameInvalid ? 'flash 1s infinite' : 'none',
                              display: 'flex',
                            }}
                          >
                            Name*
                          </span>
                        </div>
                        <div style={{ width: '100%' }}>
                          <label style={{ fontWeight: 'bold' }}></label>
                          <input
                            type="text"
                            spellCheck="false"
                            placeholder="johndoe@gmail.com"
                            value={email}
                            disabled={showCommentInput}
                            onChange={(e) => setEmail(e.target.value)}
                            required
                          />
                          <span
                            style={{
                              color: isEmailInvalid ? 'black' : 'black',
                              fontSize: '0.75rem',
                              display: 'block',
                              marginTop: '4px',
                              animation: isEmailInvalid ? 'flash 1s infinite' : 'none',
                              display: 'flex',
                            }}
                          >
                            Email*
                          </span>
                        </div>
                        {!showCommentInput && <button type="submit">Get Early Access</button>}
                      </form>

                      {showCommentInput && (
                        <>
                          <div style={{ width: '100%', marginBottom: '1rem' }}>
                            <label style={{ fontWeight: 'bold' }}></label>
                            <input
                              type="text"
                              spellCheck="false"
                              placeholder="Your Organization"
                              value={organization}
                              onChange={(e) => setOrganization(e.target.value)}
                            />
                            <span
                              style={{
                                color: 'black',
                                fontSize: '0.75rem',
                                display: 'block',
                                marginTop: '4px',
                                display: 'flex',
                              }}
                            >
                              Organization
                            </span>
                          </div>
                          <form
                            className="input-button-container"
                            style={{
                              display: 'flex',
                              alignItems: 'center',
                              gap: '8px',
                              marginBottom: '1rem',
                            }}
                            onSubmit={(e) => {
                              e.preventDefault();
                              register();
                            }}
                          >
                            <input
                              ref={commentRef}
                              type="text"
                              placeholder="Your use case?"
                              value={comment}
                              onChange={(e) => setComment(e.target.value)}
                              style={{ width: '100%' }}
                            />
                            <button type="submit">Submit</button>
                          </form>
                        </>
                      )}

                      {status !== 'idle' && (
                        <p
                          className={`response ${status}`}
                          style={{ marginTop: '8px' }}
                        >
                          {response}
                        </p>
                      )}
                    </div>
                  </div>
                </>
              }
            />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </div>

        <div className="storylens-info-section">
          <div className="info-row">
            <div className="info-label">StoryLens Team</div>
            <div className="info-content">
              <p>
                StoryLens was founded by the engineers behind Amazon's global workforce systems — overseeing staff planning, scheduling, performance management, and critical data infrastructure for millions of employees worldwide.
              </p>
              <p>
                Drawing on scale-tested insights in system design, operational clarity, and early signal detection, we're applying the lessons from some of the world's most complex environments to the realities of growing teams.
              </p>
              <p>
                StoryLens is committed to building with integrity, focusing on truth, clarity, and systems that stand the test of scale.
              </p>
            </div>
          </div>
          <div className="info-row">
            <div className="info-label">Early Access</div>
            <div className="info-content">
              <p>
                We're looking to align with early adopters and champions who can use the tool to drive real value within their organizations. If that's you,<br />
                <strong><a href="mailto:brett@netos.one" style={{ color: '#1e1e1e' }}>get in touch.</a></strong>
              </p>
            </div>
          </div>
          <div className="info-row">
            <div className="info-label">Build With Us</div>
            <div className="info-content">
              <p>
                If you're excited to help solve some of the world's biggest problems and build the next generation of distributed systems, contact us.
              </p>
            </div>
          </div>
        </div>

        <footer className="footer">
          <p className="rights">All rights reserved.</p>
          <p className="social-media">
            <a
              href="https://ca.linkedin.com/company/console-one"
              target="_blank"
              rel="noopener noreferrer"
            >
              In
            </a>
            <span> / </span>
            <a
              href="https://www.youtube.com/@ConsoleOne"
              target="_blank"
              rel="noopener noreferrer"
            >
              YT.
            </a>
          </p>
        </footer>
      </div>
    </BrowserRouter>
  );
}

export default App;
